import { Accordion, AccordionDetails, AccordionSummary, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import AccordionIcon from "../../assets/images/AccordionClose.svg";
import DocumentButton from "../../components/DocumentButton/DocumentButton";

export function EditAccessAccordion(props: {
    accordionStates: { manager: boolean; user: boolean; }; setAccordionStates: CallableFunction;
    rules: { reports: { create: boolean; read: boolean; update: boolean; }; }[]; setRules: CallableFunction; loading: boolean;
    state: "manager" | "user", label: string; onUpdate: CallableFunction;
}) {
    return <Accordion expanded={props.accordionStates[`${props.state}`]} classes={{ root: "accordion-root" }}
        onChange={() => {
            let newAccordionStates = props.accordionStates;
            newAccordionStates.manager = false;
            newAccordionStates.user = false;
            newAccordionStates[`${props.state}`] = !props.accordionStates[`${props.state}`];
            props.setAccordionStates((prevDetails: any) => ({ ...prevDetails, ...newAccordionStates, }));
        }}>
        <AccordionSummary
            classes={{
                root: "accordion-summary-root",
                content: "accordion-summary-content",
                expandIconWrapper: "icon-transform",
            }}
            sx={{
                "MuiAccordionSummary-expandIconWrapper": {
                    transform: "rotate(0deg)",
                },
            }}
            expandIcon={<img className="img" src={AccordionIcon} alt={"Arrow"} />}>
            <span className="text">{props.label}</span>
        </AccordionSummary>
        <AccordionDetails classes={{ root: "accordion-details-root" }}>
            <div className="header">
                <span>Reports</span>
                <div className="types-header">
                    <span>Yes</span>
                    <span>No</span>
                </div>
            </div>
            <div className="body">
                <Type label="Type 01" value={props.rules} onChange={props.setRules} />
                <Type label="Type 02" value={props.rules} onChange={props.setRules} />
                <Type label="Type 03" value={props.rules} onChange={props.setRules} />
            </div>
            <div className="according-footer">
                <div className="cancel-button"
                    onClick={() => {
                        props.setAccordionStates({ scribe: false, proof: false, review: false, admin: false, });
                    }}>
                    <label className="button-label">Cancel</label>
                </div>
                <div className="update-button">
                    <DocumentButton loading={props.loading} text={"Update"} onClick={() => props.onUpdate} />
                </div>
            </div>
        </AccordionDetails>
    </Accordion>;
}

function Type(props: { label: string; onChange: CallableFunction; value: any; }) {

    const [checked, setChecked] = useState({ yes: false, no: false });

    useEffect(() => {
        if (props.label === "Create") {
            setChecked({ yes: props.value[0].reports.create, no: !props.value[0].reports.create });
        } else if (props.label === "Read") {
            setChecked({ yes: props.value[0].reports.read, no: !props.value[0].reports.read });
        } else if (props.label === "Update") {
            setChecked({ yes: props.value[0].reports.update, no: !props.value[0].reports.update });
        }
    }, [props.value]);

    return (
        <div className="types">
            <span>{props.label}</span>
            <div className="boxes">
                <Checkbox checked={checked.yes}
                    sx={{
                        color: "#203FAD",
                        borderRadius: "6px",
                    }}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setChecked({ yes: event.target.checked, no: !event.target.checked });

                        let newValue = props.value;

                        if (props.label === "Create") {
                            newValue[0].reports.create = event.target.checked;
                        } else if (props.label === "Read") {
                            newValue[0].reports.read = event.target.checked;
                        } else if (props.label === "Update") {
                            newValue[0].reports.update = event.target.checked;
                        }

                        props.onChange(newValue);
                    }} />
                <Checkbox checked={checked.no}
                    sx={{
                        color: "#203FAD",
                        borderRadius: "6px",
                        "&.Mui-checked": {
                            color: "#203FAD",
                            borderRadius: "6px",
                        },
                    }}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setChecked({ yes: !event.target.checked, no: event.target.checked });

                        let newValue = props.value;
                        if (props.label === "Create") {
                            newValue[0].reports.create = !event.target.checked;
                        } else if (props.label === "Read") {
                            newValue[0].reports.read = !event.target.checked;
                        } else if (props.label === "Update") {
                            newValue[0].reports.update = !event.target.checked;
                        }

                        props.onChange(newValue);
                    }} />
            </div>
        </div>
    );
}